import Vue from 'vue'
import Vuex from 'vuex'
// import { io } from 'socket.io-client'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    socket: null,
    roomId: null,
    username: null,
    isStreamer: false,
    showWa: false,
    liveRooms: [],
    currentRoom: null,
    messages: [],
    viewerCount: 0,
    token: null
  },

  mutations: {
    SET_TOKEN(state,token) {
      state.token = token
    },
    SET_SOCKET(state, socket) {
      state.socket = socket
    },

    SET_ROOM_ID(state, roomId) {
      state.roomId = roomId
    },

    SET_USERNAME(state, username) {
      state.username = username
    },

    SET_IS_STREAMER(state, isStreamer) {
      state.isStreamer = isStreamer
    },

    SET_SHOWCONTACT(state, showWa) {
      state.showWa = showWa
    },

    SET_LIVE_ROOMS(state, rooms) {
      state.liveRooms = rooms
    },

    SET_CURRENT_ROOM(state, room) {
      state.currentRoom = room
    },

    ADD_MESSAGE(state, message) {
      state.messages.push(message)
    },

    CLEAR_MESSAGES(state) {
      state.messages = []
    },

    SET_VIEWER_COUNT(state, count) {
      state.viewerCount = count
    }
  },

  actions: {
    initializeSocket({ commit, state },data) {
      // 初始化socket连接
      // const socketHost = getHostIP()
      // const socket = io(`http://${ data.socketHost }`, {
      //   transports: ['websocket', 'polling'],
      //   timeout: 5000,
      //   reconnection: true,
      //   reconnectionAttempts: 5,
      //   reconnectionDelay: 10000
      // })

      // // 添加连接状态监听
      // socket.on('connect', () => {
      //   console.log('Socket连接成功，ID:', socket.id)
      //   console.log('连接地址:', `http://${data.socketHost}`)
      // })

      // socket.on('disconnect', () => {
      //   console.log('Socket连接断开')
      // })

      // socket.on('connect_error', (error) => {
      //   console.log('Socket连接错误:', error)
      //   console.log('尝试连接地址:', `http://${ data.socketHost}`)
      // })
      // // 使用Vue原型中的socket实例
      // // const socket = Vue.prototype.$socket

      // // 如果socket已经存在且相同，不需要重新初始化
      // if (state.socket === socket) {
      //   return socket
      // }

      // // 如果socket已经存在，先移除特定的事件监听器，避免移除所有监听器
      // if (state.socket) {
      //   state.socket.off('roomList')
      // }

      // commit('SET_SOCKET', socket)

      // // 设置通用的事件监听器（只设置一次）
      // socket.on('roomList', (rooms) => {
      //   commit('SET_LIVE_ROOMS', rooms)
      // })

      // return socket
    },

    startLive({ state, commit }, { roomId, username, title }) {
      console.log('Store startLive action被调用，参数:', { roomId, username, title })
      // if (state.socket) {
      //   console.log('发送startLive事件到服务器')
      //   state.socket.emit('startLive', { roomId, username, title })
        // commit('SET_ROOM_ID', roomId)
        // commit('SET_USERNAME', username)
        // commit('SET_IS_STREAMER', true)
      // } else {
      //   console.log('Socket未初始化，无法发送startLive事件')
      // }
    },

    joinRoom({ state, commit }, { roomId, username }) {
      if (state.socket) {
        state.socket.emit('joinRoom', { roomId, username })
        commit('SET_ROOM_ID', roomId)
        commit('SET_USERNAME', username)
        commit('SET_IS_STREAMER', false)
      }
    },

    sendMessage({ state }, message) {
      if (state.socket && state.roomId && state.username) {
        state.socket.emit('chatMessage', {
          roomId: state.roomId,
          username: state.username,
          message
        })
      }
    },

    endLive({ state }) {
      if (state.socket && state.roomId) {
        state.socket.emit('endLive', state.roomId)
        state.roomId = null
      }
    },

    getRoomList({ state }) {
      if (state.socket) {
        console.log('发送getRoomList请求')
        state.socket.emit('getRoomList')
      } else {
        console.log('Socket未初始化')
      }
    },

    updateLiveRooms({ commit }, rooms) {
      commit('SET_LIVE_ROOMS', rooms)
    },

    updateCurrentRoom({ commit }, roomInfo) {
      commit('SET_CURRENT_ROOM', roomInfo)
    },

    addMessage({ commit }, message) {
      commit('ADD_MESSAGE', message)
    },

    updateViewerCount({ commit }, count) {
      commit('SET_VIEWER_COUNT', count)
    },

    clearMessages({ commit }) {
      commit('CLEAR_MESSAGES')
    }
  },

  getters: {
    isConnected: state => state.socket && state.socket.connected,
    isInRoom: state => state.roomId !== null,
    sortedMessages: state => state.messages.slice().reverse(),
    token: state => state.token
  }
})
